<div class="deposit-info" [class.deposit-margin]="addMargin">
  <div class="deposit-header">
    <span class="icon-i-info"></span>
    <h4>{{ 'depositDelayNote.title' | translate }}</h4>
  </div>
  <p>
    {{ 'depositDelayNote.description' | translate }} <a (click)="onHelp()">{{ 'depositDelayNote.descriptionLink' | translate }}</a>
  </p>
</div>
